(function () {
  'use strict';

  var EXCLUDED = {
    '': true,
    'unbranded': true,
    'unknown': true,
    'other': true,
    'vintage': true,
    'classics': true,
    'not applicable': true
  };

  var CANONICAL = {
    'marks and spencer': { name: 'M&S', search: 'Marks & Spencer' },
    'm and s': { name: 'M&S', search: 'Marks & Spencer' },
    'h and m': { name: 'H&M', search: 'H&M' },
    'levis': { name: "Levi's", search: "Levi's" },
    'the north face': { name: 'The North Face', search: 'The North Face' }
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttr(value) {
    return escapeHtml(value);
  }

  function normalise(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[\u2018\u2019']/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function firstLetter(name) {
    var match = String(name || '').trim().match(/[a-z]/i);
    return match ? match[0].toUpperCase() : '#';
  }

  function mergeBrands(rows) {
    var indexed = {};
    (rows || []).forEach(function (row) {
      var rawName = String(row && row.name || '').trim();
      var key = normalise(rawName);
      if (!key || EXCLUDED[key]) return;
      if (!indexed[key]) {
        var canonical = CANONICAL[key] || {};
        indexed[key] = {
          name: canonical.name || rawName,
          search: canonical.search || rawName,
          count: 0,
          sold7Days: 0,
          soldToday: 0
        };
      }
      indexed[key].count += Math.max(0, Number(row.count) || 0);
      indexed[key].sold7Days += Math.max(0, Number(row.sold7Days) || 0);
      indexed[key].soldToday += Math.max(0, Number(row.soldToday) || 0);
    });
    return Object.keys(indexed).map(function (key) { return indexed[key]; });
  }

  function brandHref(root, brand) {
    var base = String(root.getAttribute('data-search-url') || '/search');
    var value = encodeURIComponent(brand.search || brand.name);
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'q=' + value + '&brand=' + value;
  }

  function fallbackBrands(root) {
    var cards = root.querySelectorAll('[data-brand-name]');
    var rows = [];
    for (var i = 0; i < cards.length; i++) {
      rows.push({
        name: cards[i].getAttribute('data-brand-name'),
        search: cards[i].getAttribute('data-brand-search'),
        count: 0,
        sold7Days: 0,
        soldToday: 0
      });
    }
    return rows;
  }

  function prepareRanks(brands) {
    var ranked = brands.slice().sort(function (a, b) {
      return b.sold7Days - a.sold7Days || b.count - a.count || a.name.localeCompare(b.name);
    });
    for (var i = 0; i < ranked.length; i++) ranked[i].weeklyRank = i + 1;
  }

  function sortedBrands(state) {
    var query = normalise(state.query);
    var list = state.brands.filter(function (brand) {
      var matchesQuery = !query || normalise(brand.name).indexOf(query) !== -1 || normalise(brand.search).indexOf(query) !== -1;
      var matchesLetter = !state.letter || firstLetter(brand.name) === state.letter;
      return matchesQuery && matchesLetter;
    });

    list.sort(function (a, b) {
      if (state.sort === 'az') return a.name.localeCompare(b.name);
      if (state.sort === 'available') return b.count - a.count || b.sold7Days - a.sold7Days || a.name.localeCompare(b.name);
      return b.sold7Days - a.sold7Days || b.count - a.count || a.name.localeCompare(b.name);
    });
    return list;
  }

  function cardMarkup(root, brand, index, state) {
    var classes = ['pwbrands__card'];
    var featured = state.sort === 'popular' && !state.query && !state.letter && brand.weeklyRank === 1 && brand.sold7Days > 0;
    if (index === 0) classes.push('pwbrands__card--hero');
    if (index > 0 && (index % 19 === 6 || index % 19 === 15)) classes.push('pwbrands__card--wide');
    if (featured) classes.push('pwbrands__card--featured');

    var badge = '';
    if (brand.weeklyRank === 1 && brand.sold7Days > 0) badge = 'TOP BRAND · 7 DAYS';
    else if (brand.weeklyRank <= 3 && brand.sold7Days > 0) badge = 'POPULAR THIS WEEK';

    var metric = brand.count > 0
      ? '<small><b>' + brand.count.toLocaleString('en-GB') + '</b> AVAILABLE NOW' +
        (brand.sold7Days > 0 ? ' · ' + brand.sold7Days.toLocaleString('en-GB') + ' SOLD THIS WEEK' : '') + '</small>'
      : '<small>EXPLORE AVAILABLE PIECES</small>';

    return '<a class="' + classes.join(' ') + '" href="' + escapeAttr(brandHref(root, brand)) +
      '" aria-label="Shop ' + escapeAttr(brand.name) + '">' +
      (badge ? '<em>' + escapeHtml(badge) + '</em>' : '') +
      '<span class="pwbrands__card-action">SHOP ' + escapeHtml(brand.name) + ' <b aria-hidden="true">\u2192</b></span>' +
      '<span class="pwbrands__card-index">' + String(index + 1).padStart(2, '0') + '</span>' +
      '<strong>' + escapeHtml(brand.name) + '</strong>' + metric + '<i aria-hidden="true">\u2197</i></a>';
  }

  function updateAlphabet(root, state) {
    var available = {};
    state.brands.forEach(function (brand) { available[firstLetter(brand.name)] = true; });
    var buttons = root.querySelectorAll('[data-pwbrands-alphabet] button');
    for (var i = 0; i < buttons.length; i++) {
      var letter = buttons[i].getAttribute('data-letter') || '';
      var active = letter === state.letter;
      buttons[i].classList.toggle('is-active', active);
      buttons[i].setAttribute('aria-pressed', active ? 'true' : 'false');
      buttons[i].disabled = Boolean(letter && !available[letter]);
    }
  }

  function render(root) {
    var state = root._pwbrandsState;
    var grid = root.querySelector('[data-pwbrands-grid]');
    var empty = root.querySelector('[data-pwbrands-empty]');
    var more = root.querySelector('[data-pwbrands-more]');
    var status = root.querySelector('[data-pwbrands-status]');
    var list = sortedBrands(state);
    var visible = list.slice(0, state.visible);
    var markup = '';

    for (var i = 0; i < visible.length; i++) markup += cardMarkup(root, visible[i], i, state);
    grid.innerHTML = markup;
    grid.setAttribute('aria-busy', 'false');
    grid.hidden = visible.length === 0;
    empty.hidden = visible.length !== 0;

    var label = state.query
      ? visible.length + ' of ' + list.length + ' matches for “' + state.query + '”'
      : 'Showing ' + visible.length + ' of ' + list.length + (state.remoteTotal > list.length && !state.letter ? '+' : '') + ' live brands';
    status.textContent = label;

    more.hidden = visible.length === 0 || visible.length >= list.length;
    if (!more.hidden) {
      var remaining = list.length - visible.length;
      more.querySelector('span').textContent = 'VIEW ' + Math.min(state.batchSize, remaining) + ' MORE';
      more.querySelector('[data-pwbrands-visible]').textContent = visible.length.toLocaleString('en-GB');
      more.querySelector('[data-pwbrands-total]').textContent = list.length.toLocaleString('en-GB') + (state.remoteTotal > list.length ? '+' : '');
    }
    updateAlphabet(root, state);
  }

  function reset(root) {
    var state = root._pwbrandsState;
    var input = root.querySelector('[data-pwbrands-search]');
    state.query = '';
    state.letter = '';
    state.visible = state.initialCount;
    input.value = '';
    root.querySelector('[data-pwbrands-clear]').hidden = true;
    render(root);
    input.focus();
  }

  function bind(root) {
    if (root.getAttribute('data-pwbrands-bound') === 'true') return;
    root.setAttribute('data-pwbrands-bound', 'true');
    var state = root._pwbrandsState;
    var input = root.querySelector('[data-pwbrands-search]');
    var clear = root.querySelector('[data-pwbrands-clear]');
    var timer = 0;

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      clear.hidden = !input.value;
      timer = window.setTimeout(function () {
        state.query = input.value.trim();
        state.visible = state.initialCount;
        render(root);
      }, 120);
    });

    clear.addEventListener('click', function () {
      input.value = '';
      clear.hidden = true;
      state.query = '';
      state.visible = state.initialCount;
      render(root);
      input.focus();
    });

    root.querySelector('[data-pwbrands-alphabet]').addEventListener('click', function (event) {
      var button = event.target.closest('button[data-letter]');
      if (!button || button.disabled) return;
      state.letter = button.getAttribute('data-letter') || '';
      state.visible = state.initialCount;
      render(root);
    });

    root.querySelector('[data-pwbrands-sort]').addEventListener('change', function (event) {
      state.sort = event.target.value;
      state.visible = state.initialCount;
      render(root);
    });

    root.querySelector('[data-pwbrands-load-more]').addEventListener('click', function () {
      state.visible += state.batchSize;
      render(root);
    });

    root.querySelector('[data-pwbrands-reset]').addEventListener('click', function () { reset(root); });
  }

  function requestBrands(root, limit, includeSold, timeoutMs) {
    var endpoint = String(root.getAttribute('data-catalog-api') || '').trim();
    if (!endpoint) return Promise.reject(new Error('Missing catalogue API URL'));
    var url;
    try {
      url = new URL(endpoint, window.location.href);
    } catch (error) {
      return Promise.reject(error);
    }
    url.searchParams.set('action', 'brands');
    if (limit > 0) url.searchParams.set('limit', String(limit));
    else url.searchParams.set('all', '1');
    url.searchParams.set('include_sold', includeSold ? '1' : '0');
    // Match the homepage URL so the browser can reuse its HTTP cache too.
    url.searchParams.set('metrics_version', '7');

    var options = { credentials: 'omit' };
    var controller = typeof window.AbortController === 'function'
      ? new window.AbortController() : null;
    var timer = 0;
    if (controller) {
      options.signal = controller.signal;
      timer = window.setTimeout(function () { controller.abort(); }, timeoutMs || 7000);
    }

    return window.fetch(url.toString(), options)
      .then(function (response) {
        if (timer) window.clearTimeout(timer);
        if (!response.ok) throw new Error('Brand directory HTTP ' + response.status);
        return response.json();
      }, function (error) {
        if (timer) window.clearTimeout(timer);
        throw error;
      })
      .then(function (payload) {
        if (!payload || !Array.isArray(payload.brands)) throw new Error('Invalid brand directory response');
        return payload;
      });
  }

  function applySalesMetrics(root, payload, replaceDirectory) {
    var state = root._pwbrandsState;
    var metrics = mergeBrands(payload.brands);
    if (!metrics.length) return;

    if (replaceDirectory) {
      prepareRanks(metrics);
      state.brands = metrics;
      state.remoteTotal = Math.max(Number(payload.totalBrands) || 0, metrics.length);
      render(root);
      return;
    }

    var metricsByName = {};
    metrics.forEach(function (brand) {
      metricsByName[normalise(brand.name)] = brand;
      metricsByName[normalise(brand.search)] = brand;
    });
    state.brands.forEach(function (brand) {
      var metric = metricsByName[normalise(brand.name)] || metricsByName[normalise(brand.search)];
      if (!metric) return;
      brand.sold7Days = metric.sold7Days;
      brand.soldToday = metric.soldToday;
    });
    prepareRanks(state.brands);
    render(root);
  }

  function loadSalesMetrics(root, replaceDirectory) {
    var state = root._pwbrandsState;
    // This exact response is prewarmed for the homepage. Reusing it avoids a
    // second large sales aggregation during a customer page view.
    return requestBrands(root, 500, true, 6000)
      .then(function (payload) { applySalesMetrics(root, payload, replaceDirectory); })
      .catch(function (error) {
        if (window.console && console.warn) {
          console.warn('[Preworn Brands] Sales metrics unavailable; keeping the fast directory.', error);
        }
      });
  }

  function load(root) {
    var state = root._pwbrandsState;
    // Availability is intentionally loaded without order metrics. The indexed
    // vendor query gives the page useful results before sales enrichment.
    requestBrands(root, 0, false, 7000)
      .then(function (payload) {
        var brands = mergeBrands(payload.brands);
        if (!brands.length) throw new Error('Empty brand directory response');
        prepareRanks(brands);
        state.brands = brands;
        state.remoteTotal = Math.max(Number(payload.totalBrands) || 0, brands.length);
        render(root);
        window.setTimeout(function () { loadSalesMetrics(root, false); }, 0);
      })
      .catch(function (error) {
        render(root);
        if (window.console && console.warn) {
          console.warn('[Preworn Brands] Fast directory unavailable; showing fallback brands.', error);
        }
        loadSalesMetrics(root, true);
      });
  }

  function initialise(root) {
    if (!root || root._pwbrandsState) return;
    var initialCount = Math.max(1, Number(root.getAttribute('data-initial-count')) || 100);
    var batchSize = Math.max(1, Number(root.getAttribute('data-batch-size')) || 100);
    var brands = fallbackBrands(root);
    prepareRanks(brands);
    root._pwbrandsState = {
      brands: brands,
      remoteTotal: brands.length,
      initialCount: initialCount,
      batchSize: batchSize,
      visible: initialCount,
      query: '',
      letter: '',
      sort: 'popular'
    };
    bind(root);
    render(root);
    load(root);
  }

  function initialiseAll(scope) {
    var roots = scope.querySelectorAll ? scope.querySelectorAll('[data-pwbrands]') : [];
    for (var i = 0; i < roots.length; i++) initialise(roots[i]);
    if (scope.matches && scope.matches('[data-pwbrands]')) initialise(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  } else {
    initialiseAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialiseAll(event.target); });
})();
